var map = {
	"./home-icon-0.png": "f06f",
	"./home-icon-1.png": "9ac2",
	"./home-icon-2.png": "66aa",
	"./home-icon-3.png": "6244",
	"./home-icon-4.png": "9bea",
	"./home-icon-5.png": "8473",
	"./home-icon-6.png": "fed4",
	"./home-icon-7.png": "97db",
	"./home-icon-8.png": "4420",
	"./home-icon-9.png": "7007"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "468a";